export default __webpack_public_path__ + "static/media/kanbanNew.dc175d4f.svg";